import httpAuth from "@/common/http-common";
import { 
  Utox,
  Icon, 
  DataContent,
  AlertZone,
  Biometrics,
  AssessmentResult,
  AssessmentHistory,
  BiometricResults,
  BasicNeeds
} from "./dashboard.types";

class DashboardService {
  async getUtox(startDate: string, endDate: string, participantId: number, clientId: number) {
    const { data } = await httpAuth().get<Utox[]>(
      '/Dashboard/GetUtox', { params: { 
        startDate: startDate,
        endDate: endDate,
        participantId: participantId,
        clientId: clientId
      } 
    });
    return data;
  }

  async getAppointments(startDate: string, endDate: string, participantId: number, clientId: number) {
    const { data } = await httpAuth().get<Icon[]>(
      '/Dashboard/GetAppointments', { params: { 
        startDate: startDate,
        endDate: endDate,
        participantId: participantId,
        clientId: clientId
      }
    });
    return data;
  }

  async getDataset(startDate: string, endDate: string, participantId: number, clientId: number, timezone: string, type?: number) {
    const { data } = await httpAuth().get<DataContent>(
      '/Dashboard/GetDataset', { params: { 
        startDate: startDate,
        endDate: endDate,
        participantId: participantId,
        type: type,
        clientId: clientId,
        timezone: timezone
      } 
    });
    return data;
  }

  async getAssessmentResults(clientId: number, participantId: number, assessmentId: number, isAssessment: boolean) {
    const { data } = await httpAuth().get<AssessmentResult[]>(
      '/Dashboard/GetAssessmentResults', { params: { 
        clientId: clientId,
        participantId: participantId,
        assessmentId: assessmentId,
        isAssessment: isAssessment
      } 
    });
    return data;
  }

  async getAssessmentHistory(clientId: number, participantId: number, startDate: string, endDate: string, type: number, timezone: string) {
    const { data } = await httpAuth().get<AssessmentHistory[]>(
      '/Dashboard/GetAssessmentHistory', { params: { 
        startDate: startDate,
        endDate: endDate,
        participantId: participantId,
        clientId: clientId,
        type: type,
        timezone: timezone
      } 
    });
    return data;
  }

  async getAlertZones(alertZoneType: number, clientId: number) {
    const { data } = await httpAuth().get<AlertZone[]>(
      '/Dashboard/GetAlertZones', { params: { 
        alertZoneType: alertZoneType,
        clientId: clientId
      } 
    });
    return data;
  }

  async getBiometricResults(startDate: string, endDate: string, participantId: number, clientId: number, timezone: string) {
    const { data } = await httpAuth().get<Biometrics[]>(
      '/Dashboard/GetBiometricResults', { params: { 
        startDate: startDate,
        endDate: endDate,
        participantId: participantId,
        clientId: clientId,
        timezone: timezone
      } 
    });
    return data;
  }

  async getBiometricResultsForDay(date: string, participantId: number, clientId: number, timezone: string) {
    const { data } = await httpAuth().get<BiometricResults[]>(
      '/Dashboard/GetBiometricResultsForDay', { params: { 
        date: date,
        participantId: participantId,
        clientId: clientId,
        timezone: timezone
      } 
    });
    return data;
  }

  async getBasicNeeds(participantId: number, clientId: number) {
    const { data } = await httpAuth().get<BasicNeeds>(
      '/Dashboard/GetBasicNeeds', { params: { 
        participantId: participantId,
        clientId: clientId,
      } 
    });
    return data;
  }
}

export default new DashboardService();